import axios from "axios";

const API = axios.create({
  baseURL: "https://admin.zedexsoftware.in/api/PFA", // updated base URL
  headers: {
    "Content-Type": "application/json",
  },
});

/* ---------- POST METHOD ---------- */
export const trackShipmentPOST = (awbno) => {
  return API.post("/TrackShipment", { awbno });
};
